import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService, addOnInvalidateHandler, invalidateResource } from "kea-resource";
import { CampoRepetidoIdentificacion, ResourceIdentificacionRepetido } from "./identificacion";
import { Factura } from './factura';

const controller = rpcController("Rep");
const crud = rpcCrudService<models.REP, models.RepDTO>(controller);

const otros = {
    Query: async (filtro: models.FiltroRep): Promise<models.RepDTO[]> => await controller('Query', {}, filtro),
    Get: async (id: number): Promise<models.RepDTO> => await controller('Get', { id }),

    /**Envía un REP por correo a una dirección de correo especifica */
    EnviarCorreo: async (idREP: number, correoDestino: string): Promise<boolean> => await controller('EnviarCorreo', { idREP, correoDestino }),

    /**Cancela una factura */
    CancelarREP: async (model: models.CancelacionREPModel): Promise<void> => await controller('CancelarREP', {}, model),

    /**Timbrar una factura */
    TimbrarREP: async (id: number): Promise<void> => await controller('TimbrarREP', { id }),

    /**Regresa el xml expedido por el SAT de un REP */
    ObtenerXML: async (id: number): Promise<string> => await controller('ObtenerXML', { id }),

    /**Regresa el pdf del REP timbrados */
    ObtenerPDF: async (id: number): Promise<string> => await controller('ObtenerPDF', { id }),

    /**Borra un REP */
    Delete: async (id: number): Promise<string> => await controller('Delete', { id }),

    /**Crea un nuevo REP */
    CrearRep: async (model: models.NuevoRepModel): Promise<number> => await controller('CrearRep', {}, model),

    /**Valida la selección de facturas para un nuevo REP, devuelve un mensaje de error o null */
    ValidarFacturasNuevoRep: async (idFacturas: number[]): Promise<string | null> => await controller('ValidarFacturasNuevoRep', {}, idFacturas),
}

export const Rep = cacheResource({
    ...otros
}, {
        Query: true,
        ObtenerPDF: true,
        ObtenerXML: true
    }, {
        Delete: true,
        TimbrarREP: true,
        CancelarREP: true,
        CrearRep: true
    });

addOnInvalidateHandler(Rep, () => invalidateResource(Factura));


// WEBPACK FOOTER //
// ./app/resources/items/rep.tsx